import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';
import { interactiveLinkStyle, pressedLinkShadow } from '../theme/constants';

export interface FundListItemStyleProps {
  forceDarkMode?: boolean;
  onlyUmbrella?: boolean;
  umbrellaColor?: string;
  isSelected?: boolean;
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
      '& $titleWithChevron': {
        '& svg path': {
          fill: theme.color.oranges[100],
        },
      },
    },
  },

  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      paddingBottom: 0,
    },
  },

  oldFundName: {
    marginTop: 4,
  },
  infoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      '& $infoBox:nth-child(1), & $infoBox:nth-child(4)': {
        paddingRight: 8,
      },
      '& $infoBox:last-child': {
        flexBasis: '100%',
        width: '100%',
      },
    },
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
      width: '50%',
    },
  },

  buttonBox: {
    marginLeft: 28,
    width: 120,
    '& button': {
      textAlign: 'center',

      [theme.breakpoints.down(theme.breakpoints.values.sl)]: {
        marginTop: 4,
      },

      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },

      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },

      '&:hover $checkmarkIcon path': {
        fill: theme.color.greys[0]
      },

      '&:active $checkmarkIcon path': {
        fill: theme.color.constants.greys[0]
      },

      '& .MuiButton-label': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }
    },

    [theme.breakpoints.down('sm')]: {
      margin: '28px 0 0',
      alignSelf: 'flex-start',
      width: '100%',
    },

    [theme.breakpoints.down('xs')]: {
      marginTop: 12,
      alignSelf: 'stretch',
    },
  },

  checkmarkIcon: {
    width: 14,
    height: 14,
    '& path': {
      fill: ({ isSelected }: FundListItemStyleProps) => isSelected ? theme.color.greys[0] : theme.color.greys[80]
    }
  },
  actionBox: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down(theme.breakpoints.values.sl)]: {
      flexDirection: 'column',
    },

    [theme.breakpoints.down('sm')]: {
      alignSelf: 'stretch',
    },
  },

  walletIcon: {
    [theme.breakpoints.down('sm')]: {
      width: 24,
      height: 24,
    },
    '& path': {
      fill: theme.color.violets[100]
    },
    '&:hover path': {
      fill: theme.color.violets[50]
    },
  },
  walletValue: {
    color: theme.color.greys[0]
  },

  fundBox: {
    [theme.breakpoints.up('md')]: {
      paddingRight: 60
    }
  },

  fundBoxPurchase: {
    [theme.breakpoints.up(theme.breakpoints.values.sl)]: {
      paddingRight: 24
    }
  },

  iconsWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 8,

    '& > *:not(:last-child)': {
      marginRight: 8,
    },
    '& svg': {
      width: 16,
      height: 16,
      [theme.breakpoints.down('sm')]: {
        width: 24,
        height: 24,
      },
    },
  },
  titleWithChevronBox: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
  },
  button: {
    '&:hover': {
      cursor: 'pointer',
      '& $text': {
        ...interactiveLinkStyle(theme),
      },
      '& $icon path': {
        fill: theme.color.violets[100],
      },
    },
    '&:active': {
      '& $textWrapper': {
        backgroundColor: pressedLinkShadow  ,
      },
    },
  },

  umbrellaWrapper: {
    display: 'flex',
    position: 'relative',
  },

  umbrellaLabelText: {
    position: 'relative',
    paddingRight: 8,
    color: ({ forceDarkMode }: FundListItemStyleProps) => forceDarkMode ? theme.color.constants.greys[0] : theme.color.greys[80]
  },
  umbrellaNameText: {
    position: 'relative',
    color: ({ forceDarkMode }: FundListItemStyleProps) => forceDarkMode ? theme.color.constants.greys[0] : theme.color.greys[80],
    paddingLeft: 4,
  },
  iconTooltipTitle: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      '& svg': {
        width: 24,
        height: 24,
      },
      '& span': {
        font: fontText('normal', theme.fontSize.base, 20),
        color: theme.color.greys[80],
      },
    },
  },
  currency: {},
  titleInline: {},
  textWrapper: {},
  text: {},
  icon: {},
}), { name: 'FundListItem', index: StylesIndexInjections.OTHER });
